import React from 'react'

/**
 * This component renders the Review Payment buttons section.
 * Expected properties:
 * - config
 * - onCancel
 * - cancelDisabled
 * - onSubmit
 * - submitLabel
 * - submitDisabled
 */
const ReviewPaymentButtons = ({ config, onCancel, cancelDisabled, onSubmit, submitLabel, submitDisabled, cancelLabel }) => {
    let cancelButton;
    let disclaimer = '';
    if (config.appCode === 'cp-opp') {
        disclaimer =  (<div className="disclaimer-payment">
            <ul>
                <li>{messages["opp.accountNotesCardSide.msg1"]}</li>
                <li>{messages["opp.accountNotesCardSide.msg2"]}</li>
            </ul>
        </div>);
        // Invisible button that pushes the submit button over to the right
        cancelButton = <button type="button" style={{ visibility: 'hidden' }} />
    } else {
        cancelButton = (
            <button
                type="button"
                className="btn btn-primary btn-account-cancel"
                data-toggle="modal"
                data-target="#modal-cancel-payment-confirm"
                onClick={onCancel}
                disabled={cancelDisabled}
                cancelLabel = {cancelLabel}
            >
                {cancelLabel || messages['opp.cancel.payment.button.label']}
            </button>
        )
    }
    return (
        <div className="card-footer flex-footer mt-3">
            {cancelButton}
            {disclaimer}
            <div className="btn-make-payment-col">
                <button
                    id="btn-opp-final-action"
                    data-action="otp"
                    type="button"
                    className="btn btn-primary waves-effect waves-light btn-make-payment"
                    onClick={onSubmit}
                    disabled={submitDisabled}
                >
                    {submitLabel}
                </button>
            </div>
        </div>
    )
}

export default ReviewPaymentButtons
